import apiClient from './client';

export interface CartLine {
    id: number;
    variant: number;
    variant_name: string;
    quantity: number;
    unit_price: string;
    line_total: string;
}

export interface Cart {
    id: number;
    lines: CartLine[];
    total: string;
    item_count: number;
    updated_at: string;
}

export interface CheckoutPayload {
    customer_name: string;
    customer_phone: string;
    shipping_city: string;
    shipping_address?: string;
    payment_method: 'cod' | 'card' | 'bank';
}

export interface SalesOrder {
    id: number;
    number: string;
    customer_name: string;
    customer_phone: string;
    status: string;
    total: string;
    created_at: string;
    is_pos_order: boolean;
}

import { tokenStore } from './client';

export const salesApi = {
    getCart: async () => {
        if (!tokenStore.getAccess()) return null;
        const { data } = await apiClient.get<Cart>('/sales/cart/');
        return data;
    },

    addToCart: async (variantId: number, quantity: number = 1) => {
        const { data } = await apiClient.post<Cart>('/sales/cart/add/', { variant_id: variantId, quantity });
        return data;
    },

    removeFromCart: async (lineId: number) => {
        const { data } = await apiClient.delete<Cart>(`/sales/cart/remove/${lineId}/`);
        return data;
    },

    checkout: async (payload: CheckoutPayload) => {
        const { data } = await apiClient.post<any>('/sales/cart/checkout/', payload);
        return data;
    },

    clearCart: async () => {
        const { data } = await apiClient.delete<{ status: string }>('/sales/cart/clear/');
        return data;
    }
};
